import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { EpicIcon } from './EpicIcon';
import { EpicName } from './EpicName';

export class EpicFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [EpicIcon, EpicName];
  }

  get title() {
    return terminology('Epic');
  }
}
